import React from "react";
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
import { numberFunction } from '_helpers';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Row,
  Col,
  Collapse,
  ListGroupItem
  // UncontrolledDropdown,
  // DropdownToggle,
  // DropdownMenu,
  // DropdownItem,
  // Table,
} from "reactstrap";
import ReactTable from 'react-table'

import { dateFromISO8601 } from '_helpers';
import { Link } from 'react-router-dom';
import noImage from "assets/img/img-livenyte/LiveNyteNoImage.jpg";



class ReviewCards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openedCollapses: [],
      // reviews: [] 
      // [revId, isSender, message, rating, time, unread, spId, spName, imageUrl, eventId]
    }
  }

  componentDidMount() {

  }


  normalizeReview = (review) => ({
    review_id: review[0],
    isSender: review[1],
    message: review[2],
    score: review[3],
    date: review[4],
    unread: review[5],
    other_member_id: review[6],
    other_name: review[7],
    other_image: review[8],
    event_id: review[9],
  });


  collapsesToggle = collapse => {
    console.log("selectedCollapse", collapse)
    const { openedCollapses } = this.state
    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapses: openedCollapses.filter(item => item !== collapse)
      });
    } else {
      const tmpArray = openedCollapses
      tmpArray.push(collapse)
      this.setState({
        openedCollapses: tmpArray
      });
    }
  };

  render() {
    const user = JSON.parse(localStorage.getItem('user'));
    const userIsSpecialist = user && user.is_specialist;
    const userIsBusiness = user && user.is_business;
    // const eventsName = this.props.eventsName
    const { reviews, eventsName } = this.props
    const displayReviews = reviews.map(this.normalizeReview);

    console.log("reviews", reviews, displayReviews)
    console.log("eventsName", eventsName)
    console.log("openedCollapses", this.state.openedCollapses)
    return (
      <Row>
        <Col xs={12} className="px-0">
          <div className='no-border-bottom-rt-tr-group'>

            <ReactTable
              data={displayReviews}
              filterable
              sortable
              showPagination={false}
              minRows={0}
              columns={[
                {
                  Header: "Reviews",
                  accessor: "date",
                  className: "wrap-cell",
                  Filter: ({ filter, onChange }) => (
                    <input
                      type="text"
                      placeholder="Search for a name"
                      value={filter ? filter.value : ""}
                      onChange={e => onChange(e.target.value)}
                      style={{ width: "100%" }}
                    />
                  ),
                  filterMethod: (filter, row) => {
                    const review = row._original;
                    const value = filter.value.toLowerCase();

                    const message = review.message?.toLowerCase() || "";
                    const otherName = review.other_name?.toLowerCase() || "";
                    const eventName =
                      eventsName?.[review.event_id]?.name?.toLowerCase() || "";
                    return (
                      message.includes(value) ||
                      otherName.includes(value) ||
                      eventName.includes(value)
                    );
                  },
                  Cell: props => {
                    const review = props.original;
                    const profilePath = userIsBusiness
                      ? `/dash/c/${numberFunction(parseInt(review.other_member_id, 10))}`
                      : `/dash/b/${numberFunction(parseInt(review.other_member_id, 10))}`;

                    return (
                      <ListGroupItem
                        className={`list-group-item-action ${review.unread ? "bg-soft-info" : ""
                          }`}
                      >
                        {/* Main Row */}
                        <Row className="align-items-center">

                          <Col className="col-auto">
                            <Link to={{ pathname: profilePath }}>
                              <img
                                className="avatar rounded-circle"
                                src={review.other_image}
                                alt={review.other_name}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = noImage;
                                }}
                              />
                            </Link>
                          </Col>

                          {/* Center content */}
                          <Col className="min-width-0 ml--2">
                            <Link to={{ pathname: `/e/${review.event_id}` }}>
                              <h4 className="mb-0 text-sm text-wrap">
                                {eventsName?.[review.event_id]?.name || ""}
                              </h4>

                              <p className="text-sm mb-0 text-wrap">
                                <span className="font-weight-light table-text">
                                  {review.message}
                                </span>
                              </p>

                              <hr className="my-2 mr-0" />
                            </Link>
                          </Col>

                          {/* Right actions / score */}
                          <Col xs="auto" className="text-right pl-1">
                            <div className="d-flex flex-column align-items-center">
                              <h1 className="">
                                {review.score}
                              </h1>

                              {/* {review.unread && (
                                <span className="badge badge-info mt-1">
                                  New
                                </span>
                              )} */}
                            </div>
                          </Col>
                        </Row>

                        {/* Footer row */}
                        <Row>
                          <Col xs={12} className="text-left">
                            <Link to={{ pathname: profilePath }}>
                              <div className="ml-6">
                                <div className="surtitle h5 pb-1">

                                  {review.other_name}
                                </div>
                                <small className="text-muted surtitle">
                                  {dateFromISO8601(
                                    review.date,
                                    eventsName?.[review.event_id]?.time_zone ||
                                    "America/Los_Angeles",
                                    "LLL"
                                  )}
                                </small>
                              </div>
                            </Link>
                          </Col>
                        </Row>
                      </ListGroupItem>
                    );
                  }
                }
              ]}
            />
          </div>
        </Col>
        {/* { reviews.length > 0 && reviews.map((review, key) =>
            <Col md={12} xs={12} key={key}>
              <Card className="card-stats">
                <CardHeader>
                  <Link to={{ pathname: `/e/${review[9]}`, }} >
                    <h4 className="title"> {eventsName.hasOwnProperty(review[9]) ? eventsName[review[9]].name : ''} </h4>
                    <h6 className="surtitle">
                      {dateFromISO8601(review[4], eventsName.hasOwnProperty(review[9]) ? eventsName[review[9]].time_zone : 'America/Los_Angeles', "LLL")}
                    </h6>
                  </Link>

                </CardHeader>

                <CardBody>
                  <Collapse
                    role="tabpanel"
                    isOpen={this.state.openedCollapses.includes(`collapse_review_${review[0]}`)}
                  >
                    <p className="line-styling text-sm">{review[2]}</p>
                  </Collapse>
                  {!this.state.openedCollapses.includes(`collapse_review_${review[0]}`) &&
                    <p className="line-styling two-line text-sm">{review[2]}</p>
                  }
                  <p className="mt-3 mb-0 text-sm" >
                    <span
                      className="text-nowrap font-weight-600 cursor-pointer"
                      role="tab"
                      onClick={() => this.collapsesToggle(`collapse_review_${review[0]}`)}
                      aria-expanded={this.state.openedCollapses.includes(
                        `collapse_review_${review[0]}`)}
                    >
                      {this.state.openedCollapses.includes(
                        `collapse_review_${review[0]}`) ? 'See less' : 'See more'}
                    </span>
                  </p>
                </CardBody>
                <CardFooter>
                  <div>
                    {userIsBusiness &&
                      <Link style={{ display: "inline-block" }} to={{
                        pathname: `/dash/c/${numberFunction(parseInt(review[6], 10))}`,
                        state: { sp_id: parseInt(review[6], 10) }
                      }}>
                        <img className="avatar-md rounded-circle mr-3" src={review[8]} alt="..." />
                      </Link>}
                    {userIsSpecialist &&
                      <Link style={{ display: "inline-block" }} to={{
                        pathname: `/dash/b/${numberFunction(parseInt(review[6], 10))}`,
                        state: { business_id: parseInt(review[6], 10) }
                      }}>
                        <img className="avatar-md rounded-circle mr-3" src={review[8]} alt="..." />
                      </Link>}

                    {userIsBusiness &&
                      <Link style={{ display: "inline-block" }} to={{
                        pathname: `/dash/c/${numberFunction(parseInt(review[6], 10))}`,
                        state: { sp_id: parseInt(review[6], 10) }
                      }}>
                        <span style={{ fontSize: '.9125rem' }}>{review[7]}</span>
                      </Link>}
                    {userIsSpecialist &&
                      <Link style={{ display: "inline-block" }} to={{
                        pathname: `/dash/b/${numberFunction(parseInt(review[6], 10))}`,
                        state: { business_id: parseInt(review[6], 10) }
                      }}>
                        <span style={{ fontSize: '.9125rem' }}> </span>{review[7]}
                      </Link>}
                    &nbsp;&nbsp; <span style={{ fontSize: '.9125rem' }} className="title">{review[3]}</span>
                  </div>
                </CardFooter>
              </Card>
            </Col>) } */}

      </Row >
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}
const connectedReviewCards = connect(mapStateToProps)(ReviewCards);

export { connectedReviewCards as ReviewCards };
